import { Button, Flex, Text } from "@chakra-ui/react";
import { SignInStyles } from "../hooks/useSignInStyles";

interface FormFooterProps {
  authStyles: any;
  styles: SignInStyles;
  isLoading: boolean;
  onSignUp: () => void;
}

export function FormFooter({ isLoading, onSignUp }: FormFooterProps) {
  return (
    <Flex
      flexDirection={{ md: "row", sm: "column-reverse" }}
      justifyContent="center"
      alignItems="start"
      w={{ md: "full", sm: "calc(100% - 60px)" }}
      columnGap="12px"
      rowGap="16px"
      margin={{ md: "0px", sm: "0px 30px" }}
      padding="0px 32px 40px 32px"
    >
      <Flex
        w="100%"
        justifyContent="center"
        alignItems="center"
        flexDirection="column"
        gap="16px"
      >
        <Button
          type="submit"
          fontSize="16px"
          bgColor="#3A7BFF"
          fontWeight="600"
          h="48px"
          color="#FFFFFF"
          minW="94px"
          borderRadius="25px"
          border="1px solid #2C63E5"
          isLoading={isLoading}
          _hover={{
            bgColor: "#FFFFFF",
            color: "#2C63E5",
          }}
          _loading={{ pointerEvents: "none" }}
          _active={{
            bgColor: "#FFFFFF",
            color: "#2C63E5",
          }}
        >
          Log in
        </Button>
        <Text
          fontSize="14px"
          fontWeight="500"
          lineHeight="17px"
          textAlign="center"
          color="#0B0E10"
        >
          Don't have an account?{" "}
          <Text
            as="span"
            color="#155EEF"
            textDecoration="underline"
            fontWeight="500"
            fontSize="14px"
            cursor="pointer"
            onClick={onSignUp}
            _hover={{ textDecoration: "underline" }}
          >
            Sign up
          </Text>
        </Text>
      </Flex>
    </Flex>
  );
}
